import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
app.initializers.add('val-ui-single-discussion-new-topic', () => {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = this.discussion;
    if (!discussion || typeof discussion.tags !== 'function') return;
    const discussionId = Number(discussion.id());
    const tags = discussion.tags() || [];
    const tag = tags.find(candidate => {
      if (!candidate || typeof candidate.attribute !== 'function') {
        return false;
      }
      const uniqueId = Number(candidate.attribute('valUniqueDiscussionId'));
      return Number.isInteger(uniqueId) && uniqueId > 0 && uniqueId === discussionId;
    });
    if (!tag) return;
    const canStartDiscussion = !app.session.user || typeof tag.canStartDiscussion === 'function' && tag.canStartDiscussion();
    items.add('valNewDiscussion', m(Button, {
      icon: 'fas fa-edit',
      className: 'Button Button--primary',
      disabled: !canStartDiscussion,
      onclick: () => {
        if (!app.session.user) {
          app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
          return;
        }
        if (!canStartDiscussion) return;

        /*
         * Recharge explicitement le tag avec son parent :
         * sur une DiscussionPage, le parent n'est pas garanti
         * d'être déjà présent dans le store.
         */
        app.store.find('tags', tag.id(), {
          include: 'parent'
        }).then(loadedTag => {
          const parent = typeof loadedTag.parent === 'function' ? loadedTag.parent() : null;
          return app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
            user: app.session.user
          }).then(() => {
            app.composer.fields.tags = parent ? [parent, loadedTag] : [loadedTag];
            app.composer.show();
          });
        });
      }
    }, 'Nouvelle discussion'), 110);
  });
});